
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("kBM1S"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("cP9vx"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("iqW94"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("14qVd"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("cdgym"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5XQG2"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("aAWAY"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lk73l"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("dQqN4"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("19qUa"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("8zmWQ"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("ipasP"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("kBM1S", function(module, exports) {

let $f00c84fb461db605$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f00c84fb461db605$var$load("2YffH"),
    $f00c84fb461db605$var$load("eNXrl"),
    $f00c84fb461db605$var$load("iUYwr"),
    $f00c84fb461db605$var$load("7o5Pu"),
    $f00c84fb461db605$var$load("jjZO0"),
    $f00c84fb461db605$var$load("AGwzU"),
    $f00c84fb461db605$var$load("lo4Uk"),
    $f00c84fb461db605$var$load("jEvZI"),
    $f00c84fb461db605$var$load("eBRUf"),
    $f00c84fb461db605$var$load("i6XKW"),
    $f00c84fb461db605$var$load("1BN67"),
    $f00c84fb461db605$var$load("2tIxk"),
    $f00c84fb461db605$var$load("dLq4a"),
    $f00c84fb461db605$var$load("h9S8v"),
    $f00c84fb461db605$var$load("27glK"),
    $f00c84fb461db605$var$load("bvY53"),
    $f00c84fb461db605$var$load("lTK3c"),
    $f00c84fb461db605$var$load("1WXdc"),
    $f00c84fb461db605$var$load("3GuOt"),
    $f00c84fb461db605$var$load("hUmZG"),
    $f00c84fb461db605$var$load("h4Nf7"),
    $f00c84fb461db605$var$load("5o4Kn"),
    $f00c84fb461db605$var$load("6rS39"),
    $f00c84fb461db605$var$load("3MYQs"),
    $f00c84fb461db605$var$load("6SWFK"),
    $f00c84fb461db605$var$load("5zapo"),
    $f00c84fb461db605$var$load("6wr18"),
    $f00c84fb461db605$var$load("9atVd"),
    $f00c84fb461db605$var$load("ffEVr"),
    $f00c84fb461db605$var$load("Y76xf"),
    $f00c84fb461db605$var$load("jbM5v"),
    $f00c84fb461db605$var$load("219St"),
    $f00c84fb461db605$var$load("b1DMS"),
    $f00c84fb461db605$var$load("lVrrs"),
    $f00c84fb461db605$var$load("3NkiL"),
    $f00c84fb461db605$var$load("1bbSu"),
    $f00c84fb461db605$var$load("kbwlB"),
    $f00c84fb461db605$var$load("Wowvf"),
    $f00c84fb461db605$var$load("cRtGo"),
    $f00c84fb461db605$var$load("eFD0t"),
    $f00c84fb461db605$var$load("dc5OW"),
    $f00c84fb461db605$var$load("s4822"),
    $f00c84fb461db605$var$load("hhss7"),
    $f00c84fb461db605$var$load("2OkLl"),
    $f00c84fb461db605$var$load("lnKog"),
    $f00c84fb461db605$var$load("h3ABO"),
    $f00c84fb461db605$var$load("kC80R"),
    $f00c84fb461db605$var$load("7EorR"),
    $f00c84fb461db605$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("cP9vx", function(module, exports) {

let $95619f7c92c52acf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $95619f7c92c52acf$var$load("2YffH"),
    $95619f7c92c52acf$var$load("eNXrl"),
    $95619f7c92c52acf$var$load("iUYwr"),
    $95619f7c92c52acf$var$load("7o5Pu"),
    $95619f7c92c52acf$var$load("jjZO0"),
    $95619f7c92c52acf$var$load("AGwzU"),
    $95619f7c92c52acf$var$load("lo4Uk"),
    $95619f7c92c52acf$var$load("jEvZI"),
    $95619f7c92c52acf$var$load("eBRUf"),
    $95619f7c92c52acf$var$load("i6XKW"),
    $95619f7c92c52acf$var$load("1BN67"),
    $95619f7c92c52acf$var$load("2tIxk"),
    $95619f7c92c52acf$var$load("dLq4a"),
    $95619f7c92c52acf$var$load("h9S8v"),
    $95619f7c92c52acf$var$load("27glK"),
    $95619f7c92c52acf$var$load("bvY53"),
    $95619f7c92c52acf$var$load("lTK3c"),
    $95619f7c92c52acf$var$load("1WXdc"),
    $95619f7c92c52acf$var$load("3GuOt"),
    $95619f7c92c52acf$var$load("hUmZG"),
    $95619f7c92c52acf$var$load("h4Nf7"),
    $95619f7c92c52acf$var$load("5o4Kn"),
    $95619f7c92c52acf$var$load("6rS39"),
    $95619f7c92c52acf$var$load("3MYQs"),
    $95619f7c92c52acf$var$load("6SWFK"),
    $95619f7c92c52acf$var$load("5zapo"),
    $95619f7c92c52acf$var$load("6wr18"),
    $95619f7c92c52acf$var$load("9atVd"),
    $95619f7c92c52acf$var$load("ffEVr"),
    $95619f7c92c52acf$var$load("Y76xf"),
    $95619f7c92c52acf$var$load("jbM5v"),
    $95619f7c92c52acf$var$load("219St"),
    $95619f7c92c52acf$var$load("b1DMS"),
    $95619f7c92c52acf$var$load("lVrrs"),
    $95619f7c92c52acf$var$load("3NkiL"),
    $95619f7c92c52acf$var$load("1bbSu"),
    $95619f7c92c52acf$var$load("kbwlB"),
    $95619f7c92c52acf$var$load("Wowvf"),
    $95619f7c92c52acf$var$load("cRtGo"),
    $95619f7c92c52acf$var$load("eFD0t"),
    $95619f7c92c52acf$var$load("dc5OW"),
    $95619f7c92c52acf$var$load("s4822"),
    $95619f7c92c52acf$var$load("hhss7"),
    $95619f7c92c52acf$var$load("2OkLl"),
    $95619f7c92c52acf$var$load("lnKog"),
    $95619f7c92c52acf$var$load("h3ABO"),
    $95619f7c92c52acf$var$load("kC80R"),
    $95619f7c92c52acf$var$load("7EorR"),
    $95619f7c92c52acf$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("iqW94", function(module, exports) {

let $d6b7c222c9b01fca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6b7c222c9b01fca$var$load("2YffH"),
    $d6b7c222c9b01fca$var$load("eNXrl"),
    $d6b7c222c9b01fca$var$load("iUYwr"),
    $d6b7c222c9b01fca$var$load("7o5Pu"),
    $d6b7c222c9b01fca$var$load("jjZO0"),
    $d6b7c222c9b01fca$var$load("AGwzU"),
    $d6b7c222c9b01fca$var$load("lo4Uk"),
    $d6b7c222c9b01fca$var$load("jEvZI"),
    $d6b7c222c9b01fca$var$load("eBRUf"),
    $d6b7c222c9b01fca$var$load("i6XKW"),
    $d6b7c222c9b01fca$var$load("1BN67"),
    $d6b7c222c9b01fca$var$load("2tIxk"),
    $d6b7c222c9b01fca$var$load("dLq4a"),
    $d6b7c222c9b01fca$var$load("h9S8v"),
    $d6b7c222c9b01fca$var$load("27glK"),
    $d6b7c222c9b01fca$var$load("bvY53"),
    $d6b7c222c9b01fca$var$load("lTK3c"),
    $d6b7c222c9b01fca$var$load("1WXdc"),
    $d6b7c222c9b01fca$var$load("3GuOt"),
    $d6b7c222c9b01fca$var$load("hUmZG"),
    $d6b7c222c9b01fca$var$load("h4Nf7"),
    $d6b7c222c9b01fca$var$load("5o4Kn"),
    $d6b7c222c9b01fca$var$load("6rS39"),
    $d6b7c222c9b01fca$var$load("3MYQs"),
    $d6b7c222c9b01fca$var$load("6SWFK"),
    $d6b7c222c9b01fca$var$load("5zapo"),
    $d6b7c222c9b01fca$var$load("6wr18"),
    $d6b7c222c9b01fca$var$load("9atVd"),
    $d6b7c222c9b01fca$var$load("ffEVr"),
    $d6b7c222c9b01fca$var$load("Y76xf"),
    $d6b7c222c9b01fca$var$load("jbM5v"),
    $d6b7c222c9b01fca$var$load("219St"),
    $d6b7c222c9b01fca$var$load("b1DMS"),
    $d6b7c222c9b01fca$var$load("lVrrs"),
    $d6b7c222c9b01fca$var$load("3NkiL"),
    $d6b7c222c9b01fca$var$load("1bbSu"),
    $d6b7c222c9b01fca$var$load("kbwlB"),
    $d6b7c222c9b01fca$var$load("Wowvf"),
    $d6b7c222c9b01fca$var$load("cRtGo"),
    $d6b7c222c9b01fca$var$load("eFD0t"),
    $d6b7c222c9b01fca$var$load("dc5OW"),
    $d6b7c222c9b01fca$var$load("s4822"),
    $d6b7c222c9b01fca$var$load("hhss7"),
    $d6b7c222c9b01fca$var$load("2OkLl"),
    $d6b7c222c9b01fca$var$load("lnKog"),
    $d6b7c222c9b01fca$var$load("h3ABO"),
    $d6b7c222c9b01fca$var$load("kC80R"),
    $d6b7c222c9b01fca$var$load("7EorR"),
    $d6b7c222c9b01fca$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("14qVd", function(module, exports) {

let $0c7b0c4c8eef7202$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c7b0c4c8eef7202$var$load("2YffH"),
    $0c7b0c4c8eef7202$var$load("iUYwr"),
    $0c7b0c4c8eef7202$var$load("jjZO0"),
    $0c7b0c4c8eef7202$var$load("AGwzU"),
    $0c7b0c4c8eef7202$var$load("jEvZI"),
    $0c7b0c4c8eef7202$var$load("eBRUf"),
    $0c7b0c4c8eef7202$var$load("i6XKW"),
    $0c7b0c4c8eef7202$var$load("1BN67"),
    $0c7b0c4c8eef7202$var$load("2tIxk"),
    $0c7b0c4c8eef7202$var$load("dLq4a"),
    $0c7b0c4c8eef7202$var$load("27glK"),
    $0c7b0c4c8eef7202$var$load("bvY53"),
    $0c7b0c4c8eef7202$var$load("lTK3c"),
    $0c7b0c4c8eef7202$var$load("1WXdc"),
    $0c7b0c4c8eef7202$var$load("3GuOt"),
    $0c7b0c4c8eef7202$var$load("hUmZG"),
    $0c7b0c4c8eef7202$var$load("h4Nf7"),
    $0c7b0c4c8eef7202$var$load("5o4Kn"),
    $0c7b0c4c8eef7202$var$load("6rS39"),
    $0c7b0c4c8eef7202$var$load("3MYQs"),
    $0c7b0c4c8eef7202$var$load("6SWFK"),
    $0c7b0c4c8eef7202$var$load("5zapo"),
    $0c7b0c4c8eef7202$var$load("6wr18"),
    $0c7b0c4c8eef7202$var$load("9atVd"),
    $0c7b0c4c8eef7202$var$load("ffEVr"),
    $0c7b0c4c8eef7202$var$load("Y76xf"),
    $0c7b0c4c8eef7202$var$load("jbM5v"),
    $0c7b0c4c8eef7202$var$load("219St"),
    $0c7b0c4c8eef7202$var$load("b1DMS"),
    $0c7b0c4c8eef7202$var$load("lVrrs"),
    $0c7b0c4c8eef7202$var$load("3NkiL"),
    $0c7b0c4c8eef7202$var$load("1bbSu"),
    $0c7b0c4c8eef7202$var$load("kbwlB"),
    $0c7b0c4c8eef7202$var$load("Wowvf"),
    $0c7b0c4c8eef7202$var$load("cRtGo"),
    $0c7b0c4c8eef7202$var$load("eFD0t"),
    $0c7b0c4c8eef7202$var$load("dc5OW"),
    $0c7b0c4c8eef7202$var$load("s4822"),
    $0c7b0c4c8eef7202$var$load("hhss7"),
    $0c7b0c4c8eef7202$var$load("2OkLl"),
    $0c7b0c4c8eef7202$var$load("h3ABO"),
    $0c7b0c4c8eef7202$var$load("kC80R"),
    $0c7b0c4c8eef7202$var$load("7EorR"),
    $0c7b0c4c8eef7202$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("cdgym", function(module, exports) {

let $8e438a1389b8e6a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e438a1389b8e6a1$var$load("2YffH"),
    $8e438a1389b8e6a1$var$load("iUYwr"),
    $8e438a1389b8e6a1$var$load("jjZO0"),
    $8e438a1389b8e6a1$var$load("AGwzU"),
    $8e438a1389b8e6a1$var$load("jEvZI"),
    $8e438a1389b8e6a1$var$load("eBRUf"),
    $8e438a1389b8e6a1$var$load("i6XKW"),
    $8e438a1389b8e6a1$var$load("1BN67"),
    $8e438a1389b8e6a1$var$load("2tIxk"),
    $8e438a1389b8e6a1$var$load("dLq4a"),
    $8e438a1389b8e6a1$var$load("27glK"),
    $8e438a1389b8e6a1$var$load("bvY53"),
    $8e438a1389b8e6a1$var$load("lTK3c"),
    $8e438a1389b8e6a1$var$load("1WXdc"),
    $8e438a1389b8e6a1$var$load("3GuOt"),
    $8e438a1389b8e6a1$var$load("hUmZG"),
    $8e438a1389b8e6a1$var$load("h4Nf7"),
    $8e438a1389b8e6a1$var$load("5o4Kn"),
    $8e438a1389b8e6a1$var$load("6rS39"),
    $8e438a1389b8e6a1$var$load("3MYQs"),
    $8e438a1389b8e6a1$var$load("6SWFK"),
    $8e438a1389b8e6a1$var$load("5zapo"),
    $8e438a1389b8e6a1$var$load("6wr18"),
    $8e438a1389b8e6a1$var$load("9atVd"),
    $8e438a1389b8e6a1$var$load("ffEVr"),
    $8e438a1389b8e6a1$var$load("Y76xf"),
    $8e438a1389b8e6a1$var$load("jbM5v"),
    $8e438a1389b8e6a1$var$load("219St"),
    $8e438a1389b8e6a1$var$load("b1DMS"),
    $8e438a1389b8e6a1$var$load("lVrrs"),
    $8e438a1389b8e6a1$var$load("3NkiL"),
    $8e438a1389b8e6a1$var$load("1bbSu"),
    $8e438a1389b8e6a1$var$load("kbwlB"),
    $8e438a1389b8e6a1$var$load("Wowvf"),
    $8e438a1389b8e6a1$var$load("cRtGo"),
    $8e438a1389b8e6a1$var$load("eFD0t"),
    $8e438a1389b8e6a1$var$load("dc5OW"),
    $8e438a1389b8e6a1$var$load("s4822"),
    $8e438a1389b8e6a1$var$load("hhss7"),
    $8e438a1389b8e6a1$var$load("2OkLl"),
    $8e438a1389b8e6a1$var$load("h3ABO"),
    $8e438a1389b8e6a1$var$load("kC80R"),
    $8e438a1389b8e6a1$var$load("7EorR"),
    $8e438a1389b8e6a1$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("5XQG2", function(module, exports) {

let $457b5300495d80b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $457b5300495d80b8$var$load("2YffH"),
    $457b5300495d80b8$var$load("iUYwr"),
    $457b5300495d80b8$var$load("jjZO0"),
    $457b5300495d80b8$var$load("AGwzU"),
    $457b5300495d80b8$var$load("jEvZI"),
    $457b5300495d80b8$var$load("eBRUf"),
    $457b5300495d80b8$var$load("i6XKW"),
    $457b5300495d80b8$var$load("1BN67"),
    $457b5300495d80b8$var$load("2tIxk"),
    $457b5300495d80b8$var$load("dLq4a"),
    $457b5300495d80b8$var$load("27glK"),
    $457b5300495d80b8$var$load("bvY53"),
    $457b5300495d80b8$var$load("lTK3c"),
    $457b5300495d80b8$var$load("1WXdc"),
    $457b5300495d80b8$var$load("3GuOt"),
    $457b5300495d80b8$var$load("hUmZG"),
    $457b5300495d80b8$var$load("h4Nf7"),
    $457b5300495d80b8$var$load("5o4Kn"),
    $457b5300495d80b8$var$load("6rS39"),
    $457b5300495d80b8$var$load("3MYQs"),
    $457b5300495d80b8$var$load("6SWFK"),
    $457b5300495d80b8$var$load("5zapo"),
    $457b5300495d80b8$var$load("6wr18"),
    $457b5300495d80b8$var$load("9atVd"),
    $457b5300495d80b8$var$load("ffEVr"),
    $457b5300495d80b8$var$load("Y76xf"),
    $457b5300495d80b8$var$load("jbM5v"),
    $457b5300495d80b8$var$load("219St"),
    $457b5300495d80b8$var$load("b1DMS"),
    $457b5300495d80b8$var$load("lVrrs"),
    $457b5300495d80b8$var$load("3NkiL"),
    $457b5300495d80b8$var$load("1bbSu"),
    $457b5300495d80b8$var$load("kbwlB"),
    $457b5300495d80b8$var$load("Wowvf"),
    $457b5300495d80b8$var$load("cRtGo"),
    $457b5300495d80b8$var$load("eFD0t"),
    $457b5300495d80b8$var$load("dc5OW"),
    $457b5300495d80b8$var$load("s4822"),
    $457b5300495d80b8$var$load("hhss7"),
    $457b5300495d80b8$var$load("2OkLl"),
    $457b5300495d80b8$var$load("h3ABO"),
    $457b5300495d80b8$var$load("kC80R"),
    $457b5300495d80b8$var$load("7EorR"),
    $457b5300495d80b8$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("aAWAY", function(module, exports) {

let $7b6ab802e4dc40df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b6ab802e4dc40df$var$load("2YffH"),
    $7b6ab802e4dc40df$var$load("iUYwr"),
    $7b6ab802e4dc40df$var$load("jjZO0"),
    $7b6ab802e4dc40df$var$load("AGwzU"),
    $7b6ab802e4dc40df$var$load("jEvZI"),
    $7b6ab802e4dc40df$var$load("eBRUf"),
    $7b6ab802e4dc40df$var$load("i6XKW"),
    $7b6ab802e4dc40df$var$load("1BN67"),
    $7b6ab802e4dc40df$var$load("2tIxk"),
    $7b6ab802e4dc40df$var$load("dLq4a"),
    $7b6ab802e4dc40df$var$load("27glK"),
    $7b6ab802e4dc40df$var$load("bvY53"),
    $7b6ab802e4dc40df$var$load("lTK3c"),
    $7b6ab802e4dc40df$var$load("1WXdc"),
    $7b6ab802e4dc40df$var$load("3GuOt"),
    $7b6ab802e4dc40df$var$load("hUmZG"),
    $7b6ab802e4dc40df$var$load("h4Nf7"),
    $7b6ab802e4dc40df$var$load("5o4Kn"),
    $7b6ab802e4dc40df$var$load("6rS39"),
    $7b6ab802e4dc40df$var$load("3MYQs"),
    $7b6ab802e4dc40df$var$load("6SWFK"),
    $7b6ab802e4dc40df$var$load("5zapo"),
    $7b6ab802e4dc40df$var$load("6wr18"),
    $7b6ab802e4dc40df$var$load("9atVd"),
    $7b6ab802e4dc40df$var$load("ffEVr"),
    $7b6ab802e4dc40df$var$load("Y76xf"),
    $7b6ab802e4dc40df$var$load("jbM5v"),
    $7b6ab802e4dc40df$var$load("219St"),
    $7b6ab802e4dc40df$var$load("b1DMS"),
    $7b6ab802e4dc40df$var$load("lVrrs"),
    $7b6ab802e4dc40df$var$load("3NkiL"),
    $7b6ab802e4dc40df$var$load("1bbSu"),
    $7b6ab802e4dc40df$var$load("kbwlB"),
    $7b6ab802e4dc40df$var$load("Wowvf"),
    $7b6ab802e4dc40df$var$load("cRtGo"),
    $7b6ab802e4dc40df$var$load("eFD0t"),
    $7b6ab802e4dc40df$var$load("dc5OW"),
    $7b6ab802e4dc40df$var$load("s4822"),
    $7b6ab802e4dc40df$var$load("hhss7"),
    $7b6ab802e4dc40df$var$load("2OkLl"),
    $7b6ab802e4dc40df$var$load("lnKog"),
    $7b6ab802e4dc40df$var$load("h3ABO"),
    $7b6ab802e4dc40df$var$load("kC80R"),
    $7b6ab802e4dc40df$var$load("7EorR"),
    $7b6ab802e4dc40df$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("lk73l", function(module, exports) {

let $f860efcb9e2963ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f860efcb9e2963ef$var$load("2YffH"),
    $f860efcb9e2963ef$var$load("iUYwr"),
    $f860efcb9e2963ef$var$load("jjZO0"),
    $f860efcb9e2963ef$var$load("AGwzU"),
    $f860efcb9e2963ef$var$load("lo4Uk"),
    $f860efcb9e2963ef$var$load("jEvZI"),
    $f860efcb9e2963ef$var$load("eBRUf"),
    $f860efcb9e2963ef$var$load("i6XKW"),
    $f860efcb9e2963ef$var$load("1BN67"),
    $f860efcb9e2963ef$var$load("2tIxk"),
    $f860efcb9e2963ef$var$load("dLq4a"),
    $f860efcb9e2963ef$var$load("h9S8v"),
    $f860efcb9e2963ef$var$load("27glK"),
    $f860efcb9e2963ef$var$load("bvY53"),
    $f860efcb9e2963ef$var$load("lTK3c"),
    $f860efcb9e2963ef$var$load("1WXdc"),
    $f860efcb9e2963ef$var$load("3GuOt"),
    $f860efcb9e2963ef$var$load("hUmZG"),
    $f860efcb9e2963ef$var$load("h4Nf7"),
    $f860efcb9e2963ef$var$load("5o4Kn"),
    $f860efcb9e2963ef$var$load("6rS39"),
    $f860efcb9e2963ef$var$load("3MYQs"),
    $f860efcb9e2963ef$var$load("6SWFK"),
    $f860efcb9e2963ef$var$load("5zapo"),
    $f860efcb9e2963ef$var$load("6wr18"),
    $f860efcb9e2963ef$var$load("9atVd"),
    $f860efcb9e2963ef$var$load("ffEVr"),
    $f860efcb9e2963ef$var$load("Y76xf"),
    $f860efcb9e2963ef$var$load("jbM5v"),
    $f860efcb9e2963ef$var$load("219St"),
    $f860efcb9e2963ef$var$load("b1DMS"),
    $f860efcb9e2963ef$var$load("lVrrs"),
    $f860efcb9e2963ef$var$load("3NkiL"),
    $f860efcb9e2963ef$var$load("1bbSu"),
    $f860efcb9e2963ef$var$load("kbwlB"),
    $f860efcb9e2963ef$var$load("Wowvf"),
    $f860efcb9e2963ef$var$load("cRtGo"),
    $f860efcb9e2963ef$var$load("eFD0t"),
    $f860efcb9e2963ef$var$load("dc5OW"),
    $f860efcb9e2963ef$var$load("s4822"),
    $f860efcb9e2963ef$var$load("hhss7"),
    $f860efcb9e2963ef$var$load("2OkLl"),
    $f860efcb9e2963ef$var$load("lnKog"),
    $f860efcb9e2963ef$var$load("h3ABO"),
    $f860efcb9e2963ef$var$load("kC80R"),
    $f860efcb9e2963ef$var$load("7EorR"),
    $f860efcb9e2963ef$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("dQqN4", function(module, exports) {

let $a144e9b4f44dbc71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a144e9b4f44dbc71$var$load("2YffH"),
    $a144e9b4f44dbc71$var$load("iUYwr"),
    $a144e9b4f44dbc71$var$load("jjZO0"),
    $a144e9b4f44dbc71$var$load("AGwzU"),
    $a144e9b4f44dbc71$var$load("lo4Uk"),
    $a144e9b4f44dbc71$var$load("jEvZI"),
    $a144e9b4f44dbc71$var$load("eBRUf"),
    $a144e9b4f44dbc71$var$load("i6XKW"),
    $a144e9b4f44dbc71$var$load("1BN67"),
    $a144e9b4f44dbc71$var$load("2tIxk"),
    $a144e9b4f44dbc71$var$load("dLq4a"),
    $a144e9b4f44dbc71$var$load("h9S8v"),
    $a144e9b4f44dbc71$var$load("27glK"),
    $a144e9b4f44dbc71$var$load("bvY53"),
    $a144e9b4f44dbc71$var$load("lTK3c"),
    $a144e9b4f44dbc71$var$load("1WXdc"),
    $a144e9b4f44dbc71$var$load("3GuOt"),
    $a144e9b4f44dbc71$var$load("hUmZG"),
    $a144e9b4f44dbc71$var$load("h4Nf7"),
    $a144e9b4f44dbc71$var$load("5o4Kn"),
    $a144e9b4f44dbc71$var$load("6rS39"),
    $a144e9b4f44dbc71$var$load("3MYQs"),
    $a144e9b4f44dbc71$var$load("6SWFK"),
    $a144e9b4f44dbc71$var$load("5zapo"),
    $a144e9b4f44dbc71$var$load("6wr18"),
    $a144e9b4f44dbc71$var$load("9atVd"),
    $a144e9b4f44dbc71$var$load("ffEVr"),
    $a144e9b4f44dbc71$var$load("Y76xf"),
    $a144e9b4f44dbc71$var$load("jbM5v"),
    $a144e9b4f44dbc71$var$load("219St"),
    $a144e9b4f44dbc71$var$load("b1DMS"),
    $a144e9b4f44dbc71$var$load("lVrrs"),
    $a144e9b4f44dbc71$var$load("3NkiL"),
    $a144e9b4f44dbc71$var$load("1bbSu"),
    $a144e9b4f44dbc71$var$load("kbwlB"),
    $a144e9b4f44dbc71$var$load("Wowvf"),
    $a144e9b4f44dbc71$var$load("cRtGo"),
    $a144e9b4f44dbc71$var$load("eFD0t"),
    $a144e9b4f44dbc71$var$load("dc5OW"),
    $a144e9b4f44dbc71$var$load("s4822"),
    $a144e9b4f44dbc71$var$load("hhss7"),
    $a144e9b4f44dbc71$var$load("2OkLl"),
    $a144e9b4f44dbc71$var$load("lnKog"),
    $a144e9b4f44dbc71$var$load("h3ABO"),
    $a144e9b4f44dbc71$var$load("kC80R"),
    $a144e9b4f44dbc71$var$load("7EorR"),
    $a144e9b4f44dbc71$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("19qUa", function(module, exports) {

let $0d6b80750e788048$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d6b80750e788048$var$load("2YffH"),
    $0d6b80750e788048$var$load("iUYwr"),
    $0d6b80750e788048$var$load("jjZO0"),
    $0d6b80750e788048$var$load("AGwzU"),
    $0d6b80750e788048$var$load("jEvZI"),
    $0d6b80750e788048$var$load("eBRUf"),
    $0d6b80750e788048$var$load("i6XKW"),
    $0d6b80750e788048$var$load("1BN67"),
    $0d6b80750e788048$var$load("2tIxk"),
    $0d6b80750e788048$var$load("dLq4a"),
    $0d6b80750e788048$var$load("27glK"),
    $0d6b80750e788048$var$load("bvY53"),
    $0d6b80750e788048$var$load("lTK3c"),
    $0d6b80750e788048$var$load("1WXdc"),
    $0d6b80750e788048$var$load("3GuOt"),
    $0d6b80750e788048$var$load("hUmZG"),
    $0d6b80750e788048$var$load("h4Nf7"),
    $0d6b80750e788048$var$load("5o4Kn"),
    $0d6b80750e788048$var$load("6rS39"),
    $0d6b80750e788048$var$load("3MYQs"),
    $0d6b80750e788048$var$load("6SWFK"),
    $0d6b80750e788048$var$load("5zapo"),
    $0d6b80750e788048$var$load("6wr18"),
    $0d6b80750e788048$var$load("9atVd"),
    $0d6b80750e788048$var$load("ffEVr"),
    $0d6b80750e788048$var$load("Y76xf"),
    $0d6b80750e788048$var$load("jbM5v"),
    $0d6b80750e788048$var$load("219St"),
    $0d6b80750e788048$var$load("b1DMS"),
    $0d6b80750e788048$var$load("lVrrs"),
    $0d6b80750e788048$var$load("3NkiL"),
    $0d6b80750e788048$var$load("1bbSu"),
    $0d6b80750e788048$var$load("kbwlB"),
    $0d6b80750e788048$var$load("Wowvf"),
    $0d6b80750e788048$var$load("cRtGo"),
    $0d6b80750e788048$var$load("eFD0t"),
    $0d6b80750e788048$var$load("dc5OW"),
    $0d6b80750e788048$var$load("s4822"),
    $0d6b80750e788048$var$load("hhss7"),
    $0d6b80750e788048$var$load("2OkLl"),
    $0d6b80750e788048$var$load("h3ABO"),
    $0d6b80750e788048$var$load("kC80R"),
    $0d6b80750e788048$var$load("7EorR"),
    $0d6b80750e788048$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("8zmWQ", function(module, exports) {

let $63d364a211fd7134$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63d364a211fd7134$var$load("2YffH"),
    $63d364a211fd7134$var$load("iUYwr"),
    $63d364a211fd7134$var$load("jjZO0"),
    $63d364a211fd7134$var$load("AGwzU"),
    $63d364a211fd7134$var$load("jEvZI"),
    $63d364a211fd7134$var$load("eBRUf"),
    $63d364a211fd7134$var$load("i6XKW"),
    $63d364a211fd7134$var$load("1BN67"),
    $63d364a211fd7134$var$load("2tIxk"),
    $63d364a211fd7134$var$load("dLq4a"),
    $63d364a211fd7134$var$load("27glK"),
    $63d364a211fd7134$var$load("bvY53"),
    $63d364a211fd7134$var$load("lTK3c"),
    $63d364a211fd7134$var$load("1WXdc"),
    $63d364a211fd7134$var$load("3GuOt"),
    $63d364a211fd7134$var$load("hUmZG"),
    $63d364a211fd7134$var$load("h4Nf7"),
    $63d364a211fd7134$var$load("5o4Kn"),
    $63d364a211fd7134$var$load("6rS39"),
    $63d364a211fd7134$var$load("3MYQs"),
    $63d364a211fd7134$var$load("6SWFK"),
    $63d364a211fd7134$var$load("5zapo"),
    $63d364a211fd7134$var$load("6wr18"),
    $63d364a211fd7134$var$load("9atVd"),
    $63d364a211fd7134$var$load("ffEVr"),
    $63d364a211fd7134$var$load("Y76xf"),
    $63d364a211fd7134$var$load("jbM5v"),
    $63d364a211fd7134$var$load("219St"),
    $63d364a211fd7134$var$load("b1DMS"),
    $63d364a211fd7134$var$load("lVrrs"),
    $63d364a211fd7134$var$load("3NkiL"),
    $63d364a211fd7134$var$load("1bbSu"),
    $63d364a211fd7134$var$load("kbwlB"),
    $63d364a211fd7134$var$load("Wowvf"),
    $63d364a211fd7134$var$load("cRtGo"),
    $63d364a211fd7134$var$load("eFD0t"),
    $63d364a211fd7134$var$load("dc5OW"),
    $63d364a211fd7134$var$load("s4822"),
    $63d364a211fd7134$var$load("hhss7"),
    $63d364a211fd7134$var$load("2OkLl"),
    $63d364a211fd7134$var$load("lnKog"),
    $63d364a211fd7134$var$load("h3ABO"),
    $63d364a211fd7134$var$load("kC80R"),
    $63d364a211fd7134$var$load("7EorR"),
    $63d364a211fd7134$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("ipasP", function(module, exports) {

let $d662adb663ad9544$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d662adb663ad9544$var$load("2YffH"),
    $d662adb663ad9544$var$load("iUYwr"),
    $d662adb663ad9544$var$load("jjZO0"),
    $d662adb663ad9544$var$load("AGwzU"),
    $d662adb663ad9544$var$load("jEvZI"),
    $d662adb663ad9544$var$load("eBRUf"),
    $d662adb663ad9544$var$load("i6XKW"),
    $d662adb663ad9544$var$load("1BN67"),
    $d662adb663ad9544$var$load("2tIxk"),
    $d662adb663ad9544$var$load("dLq4a"),
    $d662adb663ad9544$var$load("27glK"),
    $d662adb663ad9544$var$load("bvY53"),
    $d662adb663ad9544$var$load("lTK3c"),
    $d662adb663ad9544$var$load("1WXdc"),
    $d662adb663ad9544$var$load("3GuOt"),
    $d662adb663ad9544$var$load("hUmZG"),
    $d662adb663ad9544$var$load("h4Nf7"),
    $d662adb663ad9544$var$load("5o4Kn"),
    $d662adb663ad9544$var$load("6rS39"),
    $d662adb663ad9544$var$load("3MYQs"),
    $d662adb663ad9544$var$load("6SWFK"),
    $d662adb663ad9544$var$load("5zapo"),
    $d662adb663ad9544$var$load("6wr18"),
    $d662adb663ad9544$var$load("9atVd"),
    $d662adb663ad9544$var$load("ffEVr"),
    $d662adb663ad9544$var$load("Y76xf"),
    $d662adb663ad9544$var$load("jbM5v"),
    $d662adb663ad9544$var$load("219St"),
    $d662adb663ad9544$var$load("b1DMS"),
    $d662adb663ad9544$var$load("lVrrs"),
    $d662adb663ad9544$var$load("3NkiL"),
    $d662adb663ad9544$var$load("1bbSu"),
    $d662adb663ad9544$var$load("kbwlB"),
    $d662adb663ad9544$var$load("Wowvf"),
    $d662adb663ad9544$var$load("cRtGo"),
    $d662adb663ad9544$var$load("eFD0t"),
    $d662adb663ad9544$var$load("dc5OW"),
    $d662adb663ad9544$var$load("s4822"),
    $d662adb663ad9544$var$load("hhss7"),
    $d662adb663ad9544$var$load("2OkLl"),
    $d662adb663ad9544$var$load("lnKog"),
    $d662adb663ad9544$var$load("h3ABO"),
    $d662adb663ad9544$var$load("kC80R"),
    $d662adb663ad9544$var$load("7EorR"),
    $d662adb663ad9544$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("8WjFq"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("8WjFq", function(module, exports) {

let $6822ff017737725d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6822ff017737725d$var$load("2OkLl"),
    $6822ff017737725d$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2JC3k")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $d977f97374f9d2c9$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $d977f97374f9d2c9$export$586232a3e4271798;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $aXWIB = parcelRequire("aXWIB");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $aXWIB.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $aXWIB.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cOrQJ = parcelRequire("cOrQJ");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $dm7Aa = parcelRequire("dm7Aa");


var $eufiU = parcelRequire("eufiU");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $aXWIB.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $42omo.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("dm7Aa", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("eufiU", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $1P1Tu.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $9zUhf.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $9zUhf.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});


//# sourceMappingURL=ForgeContentTools.dcade799.js.map
